import { handleRequest } from ".";
import { httpAuthorized } from "@/main";

/** 终端协议文件中英对照 */
export interface ProtocolFile {
  /** 终端返回的原始文件名 */
  fileName: string;
  /** 设备中文名称（解析得到，可能为空） */
  devName: string | null;
  /** 英文名称（去后缀） */
  enName: string;
  /** 是否已匹配翻译表（true=已匹配，false=未匹配） */
  matched: boolean;
  /** 最近一次[5,7]同步时间（格式化字符串，仅列表查询返回） */
  syncTime: string | null;
}

/** 库有板无的设备（后端存在、终端无对应协议文件，提示可删除） */
export interface MissingDevice {
  /** 设备 ID */
  deviceId: string;
  /** 设备中文名（nameCn 为空时回退英文） */
  devName: string;
  /** 设备英文键名 */
  enName: string;
  /** 协议文件名（为空说明设备未推送过协议） */
  protName: string | null;
  /** 是否已置灰（用户端对账标记的"终端文件丢失"） */
  terminalMissing: boolean;
}

/** [5,7] 同步结果：终端文件列表 + 库有板无对账清单 */
export interface SyncResult {
  /** 终端协议文件中英对照列表 */
  files: ProtocolFile[];
  /** 缺失协议文件的后端设备（空数组=对账无差异） */
  missingDevices: MissingDevice[];
}

/**
 * [5,7] 同步终端协议文件列表（下发读取命令，等待终端返回，全量更新缓存 + 只读对账：
 * 库有板无 -> missingDevices 提示可删除；板有库无 -> 忽略）
 */
export const syncProtocolFilesApi = async (
  shipId: string
): Promise<SyncResult | null> => {
  return handleRequest<SyncResult>(
    httpAuthorized.post("/svc005/syncProtocolFiles", null, {
      params: { shipId },
    }),
    (data) => data.data.result
  );
};

/**
 * 查询所有翻译对应关系（svc_device_name_translation 全表）
 */
export const listTranslationsApi = async (): Promise<ProtocolFile[] | null> => {
  return handleRequest<ProtocolFile[]>(
    httpAuthorized.get("/svc005/translations"),
    (data) => data.data.result
  );
};

/**
 * 查询终端协议文件缓存（按终端ID，附带库有板无对账清单）
 */
export const listProtocolFilesApi = async (
  shipId: string
): Promise<SyncResult | null> => {
  return handleRequest<SyncResult>(
    httpAuthorized.get("/svc005/protocolFiles", {
      params: { shipId },
    }),
    (data) => data.data.result
  );
};

/**
 * 手动添加翻译对应关系（未匹配文件加入翻译表）
 */
export const addTranslationApi = async (
  shipId: string,
  enName: string,
  devName: string
): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.post("/svc005/addTranslation", null, {
      params: { shipId, enName, devName },
    }),
    (data) => data.data.result
  );
};
